export default "__VITE_ASSET__pTnrnSZn__"